import React from "react";
// import WithSidebar from "../components/layout/WithSidebar";
const Membership = () => {
  return <>Memeber ship Price</>;
};

export default Membership;
